import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalSelecionarMapasPageRoutingModule } from './modal-selecionar-mapas-routing.module';

import { ModalSelecionarMapasPage } from './modal-selecionar-mapas.page';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxMaskModule.forRoot(),
    ModalSelecionarMapasPageRoutingModule
  ],
  declarations: [ModalSelecionarMapasPage]
})
export class ModalSelecionarMapasPageModule {}
